import classnames from 'classnames';
import clipboard from 'copy-to-clipboard';
import React, { useState, useRef, useCallback, useContext } from 'react';
import Button from '../../wui-button/src';
import { WebUI, getNid } from "../../wui-core/src/index";
import Icon from '../../wui-icon/src';
import Input from '../../wui-input/src';
import { getLangInfo } from '../../wui-locale/src/tool';
import {ConfigContext} from '../../wui-provider/src/context';
import Modal from '../../wui-modal/src';
import Tooltip from '../../wui-tooltip/src';
import i18n from './i18n.js';
import { ClipboardProps } from './iClipboard.js';

const defaultProps = {
    action: 'copy',
    text: '',
    target: '',
    success: () => {},
    error: () => {}
};

const Clipboard: React.FC<ClipboardProps> = (props) => {
    const context = useContext(ConfigContext)
    const [currect, setCurrect] = useState(false);
    const [html, setHtml] = useState('');
    const [ready, setReady] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const textRef = useRef<HTMLElement | null>(null);

    const copyHandle = useCallback(() => {
        let { action, text, target, success, error, asyncCopy } = props;
        let copyContent = '';
        if (text) {
            copyContent = text;
            action = 'copy';
        } else if (target) {
            const el = document.querySelector(target) as any;
            if (el) {
                if (action === 'copy') {
                    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
                        copyContent = el.value;
                    } else {
                        copyContent = el.innerText;
                    }
                } else {
                    copyContent = el.value;
                    el.value = '';
                }
            }
        }
        if (asyncCopy) {
            asyncCopy(clipboard);
        } else {
            try {
                if (clipboard(copyContent)) {
                    setCurrect(true);
                    setReady(true);
                    if (success instanceof Function) success();
                } else {
                    setModalShow(true);
                    setHtml(copyContent);
                    if (error instanceof Function) error();
                }
            } catch (e) {
                setModalShow(true);
                setHtml(copyContent);
                if (error instanceof Function) error();
            }
        }
    }, [props]);

    const blur = useCallback(() => {
        setCurrect(false);
        setReady(false);
    }, []);

    const close = useCallback((e?: React.MouseEvent<HTMLElement>) => {
        e && e.stopPropagation();
        setModalShow(false);
    }, []);

    const { clsPrefix, action, fieldid, locale, className, children } = props;
    const local = getLangInfo(locale || context.locale, i18n, 'clipboard');
    let tootipContent = local.langMap[action];
    if (ready) {
        tootipContent = local.langMap[`${action}Ready`];
    }
    let wrapperClass = classnames({
        [`${clsPrefix}`]: true,
        [`${className}`]: className
    });
    let adapterNid = getNid(props);

    return (
        <Tooltip className={`${clsPrefix}-tooltip`} overlay={tootipContent} placement="top">
            <span
                onClick={copyHandle}
                onMouseOut={blur}
                className={wrapperClass}
                fieldid={fieldid}
                {...adapterNid}
            >
                {children ? (
                    children
                ) : (
                    <Icon
                        className={classnames({
                            'uf-correct': currect,
                            'uf-copy': !currect
                        })}
                    />
                )}
                <Modal show={modalShow} onCancel={close}>
                    <Modal.Header closeButton>
                        <Modal.Title> Ctrl+C {local.langMap.copyToClipboard} </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Input ref={textRef as any} type="text" readOnly value={html} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={close}> {local.langMap.close} </Button>
                    </Modal.Footer>
                </Modal>
            </span>
        </Tooltip>
    );
};

export default WebUI({ name: "clipboard", defaultProps })(Clipboard);
